import React, { MutableRefObject } from 'react'
import { OfferPageState } from './offerPageStateReducer'

// TODO: Re-assess if we even still need this. Nothing's reading the context.

// @ts-ignore
const OfferPageStateSnapshotContext = React.createContext<MutableRefObject<OfferPageState>>(undefined)

export default OfferPageStateSnapshotContext
